import { Component, HostListener, Input } from '@angular/core';
import { Router } from '@angular/router';
import { TransactionStatesEnum } from '@app/core/enums/transaction-states.enum';
import { GlobalStateService } from '@app/core/services/global-state.service';
import { StatesService } from '@app/core/services/states.service';
import { SystemsService } from '@app/core/services/systems.service';
import { Transaction } from '@app/transactions/transaction';
import { StateActionsService } from '../../../../core/resources/state-action';
import { System } from '../../../../core/resources/system';
import { SystemMarketEnum } from '../../../../../ui/shared/enums/system-market.enum';

@Component({
    selector: 'app-row-transaction-list',
    templateUrl: './row-transaction-list.component.html',
    styleUrls: ['./row-transaction-list.component.scss']
})
export class RowTransactionListComponent {
    @Input() public userTransactions: { [key: string]: any } = {};
    @Input() public transaction: Transaction = new Transaction();
    @Input() public publicTransaction: boolean = false;
    @Input() public isLast: boolean = true;
    @Input() public opacity: boolean = true;
    public stateEnum: typeof TransactionStatesEnum = TransactionStatesEnum;
    public beforepath: string = 't';
    public beforepathCreate: string = 't';
    public panelOpenState: boolean = false;
    public transaction_list_mobile: boolean = false;
    public isButtonVisible: boolean = false;

    public constructor(
        public statesService: StatesService,
        public stateActionsService: StateActionsService,
        public systemService: SystemsService,
        public globalStateService: GlobalStateService,
        private router: Router
    ) {
        this.checkSizeScreen(window.innerWidth);
    }

    public setUrlDetail(): void {
        let routeRedirect: string = '/my/dashboard/transactions/v3/' + this.transaction.id + '/instructions';
        if (!this.publicTransaction) {
            this.router.navigate([routeRedirect]);
        }
    }

    public hideButton(): void {
        this.isButtonVisible = false;
    }

    @HostListener('window:resize', ['$event'])
    public setListByScreen(event: any): void {
        this.checkSizeScreen(event.target.innerWidth);
    }

    public checkSizeScreen(width: number): void {
        if (width < 980) {
            this.transaction_list_mobile = true;
        } else {
            this.transaction_list_mobile = false;
        }
    }

    public getAmountBySystem(): number {
        const system2: System | undefined | null = this.transaction.relationships.system2.data;
        if (system2?.attributes?.market === SystemMarketEnum.PRODUCT) {
            return 0;
        }

        return this.transaction.attributes.amount2;
    }
}
